import { Resource, Form, BaseModel, Entry } from "@ngx-resource-toolkit/core";
import { environment } from "../../../environments/environment";
import { LeaResource } from "../resource/lea.resource";


@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/php',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'create': {}
})
export class ExportExcelModel extends BaseModel {

    @Entry({
        'create': {
            hidden: true,
        }
    })
    nomFichierPhysique: string;

    @Entry({
        'create': {
            hidden: true,
        }
    })
    nomFichierVisible: string;

    @Entry({
        'create': {
            hidden: true,
        }
    })
    idFichier: number = null;

    constructor(physique: string, visible: string, idFichier?) {
        super();

        this.nomFichierPhysique = physique;
        this.nomFichierVisible = visible;
        if (idFichier) {
            this.idFichier = idFichier;
        }
    }
}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/export-excel/export-excel.model.ts